import { Component, EventEmitter, Output } from '@angular/core';
import { PermissionsEnum } from '@shared/models/permissions';

@Component({
  selector: 'app-ag-grid-no-views-available',
  templateUrl: './ag-grid-no-views-available.component.html',
  styleUrl: './ag-grid-no-views-available.component.scss'
})
export class AgGridNoViewsAvailableComponent {

  permissions = PermissionsEnum;

  @Output() createViewClicked: EventEmitter<boolean> = new EventEmitter();

}
